import { ConnectorUdmSpec } from '@integration-app/sdk'
import { IntegrationCollectionType } from 'routes/Integrations/helpers/types'
import { IntegrationDataCollectionsCard } from './DataCollectionsCard'
import common from 'routes/Integrations/Integration/Integration.module.scss'

export function IntegrationDataCollectionsList({
  dataCollections,
  udms,
  integrationLink,
}: {
  dataCollections: IntegrationCollectionType[]
  udms: ConnectorUdmSpec[]
  integrationLink: string
}) {
  const findUdms = (udms: ConnectorUdmSpec[], dataKey: string) => {
    const udm: string[] = []

    Object.keys(udms).forEach((key) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      udms[key].collectionMappings?.filter((i: Record<string, any>) => {
        if (i.key === dataKey) {
          udm.push(key)
        }
      })
    })

    return udm
  }

  return (
    <ul className={common.integrationList}>
      {dataCollections &&
        dataCollections.map((collection) => (
          <IntegrationDataCollectionsCard
            key={collection.key}
            collection={collection}
            udmsData={findUdms(udms, collection.key)}
            integrationLink={integrationLink}
          />
        ))}
    </ul>
  )
}
